export interface State {
  currCity: string;
  mallPosition: boolean;
  homePosition: boolean;
  diseasePosition: boolean;
}

const model = {
  name: 'location',
  persist: false,
  state: {
    currCity: '',
    // 首页都只定位一次
    mallPosition: true,
    homePosition: true,
    diseasePosition: true,
  } as State,
  baseReducer(state: State, action: any) {
    return state;
  },
  reducers: {
    setCity(state: State, payload: State['currCity']) {
      state.currCity = payload;
    },
    setMallPosition(state: State, payload: State['mallPosition']) {
      state.mallPosition = payload;
    },
    setHomePosition(state: State, payload: State['homePosition']) {
      state.homePosition = payload;
    },
    setDiseasePosition(state: State, payload: State['diseasePosition']) {
      state.diseasePosition = payload;
    },
  },
  effects: {},
};

export default model;
